import React, { useState } from 'react';

interface HamburgerMenuCategoryAccordionProps {
  rootCategory: any;
  useAsLink?: boolean;
}

const HamburgerMenuCategoryAccordion: React.FC<HamburgerMenuCategoryAccordionProps> = ({ rootCategory, useAsLink = false }) => {
  const [active, setActive] = useState(false);

  const getGetChildCatagory = (child: any) => {
    const settings = JSON.parse(child.settings || null);
    const hasMenuSticker = settings?.categories_menu_sticker;
    return (
      <a href={child.uri}>
        <span className={`${hasMenuSticker ? "has-menu-sticker" : ""}`}>{child.title}</span>
        <span> &gt;</span>{/* right arrow */}
        {hasMenuSticker && (
          <span className="categories_menu_sticker">
            {/* grern "NEU" in de site */}
            {settings.categories_menu_sticker}
          </span>
        )
        }
      </a>
    )
  }

  return (
    <div className="root-category-accordion">
      <>
  {useAsLink ? (
    <div className="root-category-accordion-head">
      <a
        href={rootCategory.uri}
        className="root-category-title"
        style={{
          textDecoration: "none",
          color: "#00294e",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          width: "100%"
        }}
      >
        <span style={{ flex: 1 }}>{rootCategory.title}</span>
        <img
          className="chevron-icon chevron-right"
          src={require("../../../icons/Chevron-Down-Secondary.svg").default}
          alt="Chevron"
          style={{ transform: "rotate(-90deg)" }}
        />
      </a>
    </div>
  ) : (
    <div
      onClick={() => setActive((current) => !current)}
      className="root-category-accordion-head"
    >
      <h4 className={`root-category-title${active ? "-active" : ""}`}>
        {rootCategory.title}
      </h4>
      <img
        className={`chevron-icon ${active ? "chevron-up" : "chevron-down"}`}
        src={require("../../../icons/Chevron-Down-Secondary.svg").default}
        alt="Chevron"
      />
    </div>
  )}

  {!useAsLink && active && (
    <ul className="child-categories">
      {rootCategory.children.map((child: any) => (
        <li key={child.id} className="child-category">
          {getGetChildCatagory(child)}
        </li>
      ))}
    </ul>
  )}
</>


    </div>

  );
};



export default HamburgerMenuCategoryAccordion;
